import React from "react";
import { Page } from "../01-sections/Page";
import { LoadingIndicator, LoadingIndications } from "../../05-atoms/LoadingIndicator";
import { RTE } from "../../07-organisms/RTE";
import { Div } from "../../03-base/Div";
import { Container } from "../../03-base/Container";
import * as I18n from "../../../../utils/translations/I18n";
export var Loading = function (_props) { return (React.createElement(Page, null,
    React.createElement(Container, { theme: {
            padding: {
                "": { y: 3 },
                "sm": { y: 4 },
            },
        } },
        React.createElement(LoadingIndicator, { type: LoadingIndications.DEFAULT }),
        React.createElement(Div, { theme: {
                padding: {
                    "": { b: 3 },
                    "sm": { b: 4 },
                },
            }, className: "scl-h-text-align--center" },
            React.createElement(RTE, { content: I18n.getText("mary.09-views.02-pages.loading.description", "Retrieving content..") }))))); };
